import axios from 'axios'
import status from './status'
import campos from './campos'
import store from '@/vuex'
import { Notification as notify } from 'element-ui'
import Vue from 'vue'
export const eventBus = new Vue();

/* create axios factory */
const http = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: process.env.TIMEOUT || 0,
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
})

/* include token in header */
if (localStorage.getItem('truckme-auth')) {
  http.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${localStorage.getItem('truckme-auth')}`
}

/* handle default response  */
http.interceptors.response.use(
  function(response) {
    console.log(
      'URL:' +
        response.config.url +
        ' | STATUS_CODE: ' +
        response.status +
        ' | STATUS_TEXT: ' +
        status[response.status]
    )
    return response
  },
  function(error) {
    if (error.response) {
      let message =
        typeof error.response.data === 'object'
          ? error.response.data.message.replace('<b>Atenção!</b> ', '')
          : 'Erro ao salvar o registro.'
      if (error.response.status === 401) {
        const message = error.response.data.message
          ? error.response.data.message
          : 'Combinação informada não confere ou a sessão expirou. Faça login novamente.'
        notify.error({
          title: status[error.response.status],
          message: message,
          offset: 100,
          duration: 0,
        })
        store.dispatch('setLoginExpired', true)
      } else if (error.response.status === 404) {
        const message = 'A busca não encontrou registro'
        notify.warning({
          title: status[error.response.status],
          message: message,
          offset: 100,
          duration: 0,
        })
      } else {
        if (typeof error.response.data.message === 'object') {
          let { mensagem, validacoes } = JSON.parse(error.response.data.message)

          if (mensagem && validacoes) {
            notify.error({
              title: status[error.response.status],
              message: mensagem,
              offset: 100,
              duration: 0,
            })

            if (validacoes && validacoes.length > 0) {
              let fields = validacoes
              let errors =
                '<ul>' +
                fields
                  .map((error) => {
                    return '<li>' + error + '</li>'
                  })
                  .join('')
              ;+'<ul>'
              notify.error({
                title: 'Erros',
                message: errors,
                offset: 170,
                dangerouslyUseHTMLString: true,
                duration: 0,
              })
            }
          }
        }

        if (error.request.responseURL.includes('emitirDocumentosFiscais')) {
          const freteId = error.request.responseURL.split('emitirDocumentosFiscais/')[1]
          eventBus.$emit('frete-erro-emitir-documentos-fiscais', freteId)
        }

        notify.error({
          title: status[error.response.status],
          message: message,
          offset: 100,
          duration: 0
        })

        if (
          error.response.data.fields &&
          error.response.data.fields.length > 0
        ) {
          let fields = error.response.data.fields
          let errorFields = fields.map((errorField) => {
            if (campos[errorField.field]) {
             return `<li>${campos[errorField.field]}: ${errorField.message}</li>`
            }
            return `<li>${errorField.message}</li>`
          }).join('');
          let errors = `<ul>${errorFields}<ul>`
          notify.error({
            title: 'Campos inválidos',
            message: errors,
            offset: 170,
            dangerouslyUseHTMLString: true,
            duration: 0,
          })
        }
      }
      return false
    } else if (error.request) {
      // The request was made but no response was received `error.request` is an instance of XMLHttpRequest
      notify.error({
        title: 'Oops',
        message: 'Não foi possível alcançar o servidor. Verifique sua conexão com a internet.',
        offset: 100,
        duration: 0,
      })
      // console.log(error.request)
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error:', error.message)
    }

    return Promise.reject(error)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/services/axios.js